import $ from 'jquery';
import { EventBus } from "../../utils/event-bus";
import { handleValidateImageUpload } from '../../components/modals/New_RoundTable/EditorMCE/Utils/ValidateImageUpload';
import { handleValidateFileUpload } from '../../components/modals/New_RoundTable/EditorMCE/Utils/ValidateFileUpload';
const EditorOptions = {
  menubar: false,
  disabled: true,
  license_key: 'gpl',
  paste_data_images: false,
  automatic_uploads: false,
  paste_block_drop: true,
  paste_block_img_drop: true,
  height: '100%',
  plugins: 'lists link image preview visualblocks autolink media preview searchreplace wordcount',
  toolbar: 'undo redo | blocks | visualblocks | bold italic | alignleft aligncenter alignright | bullist numlist | link imageupload fileupload media | preview',
  skin_url: '/static/tinymce/parlay/ui/Parlay/',
  content_css: '/static/tinymce/parlay/content/Parlay/content.css',
  content_style: `
    .mce-content-body {
      padding-bottom: 48px
    }
  `,
  branding: false,
  iframe_attrs: {
    sandbox: 'allow-scripts allow-same-origin'
  },
  statusbar: false,
  resize: false,
  forced_root_block: 'h1',
  indent: false,
  valid_elements: '*[*]',
  elementpath: true,
  extended_valid_elements: '*[*]',
  cleanup: false,
  verify_html: false,
  link_default_target: '_blank',
  link_target_list: false,
  media_alt_source: false,
  media_poster: false,
  media_dimensions: false,
  quickbars_selection_toolbar: 'bold italic underline | genieRevise | bullist numlist | blockquote quicklink',
  setup: function (editor) {
    editor.on('init', function () {
      const contentIframe = editor.getContentAreaContainer().querySelector('iframe');
      if (contentIframe) {
        contentIframe.removeAttribute('sandbox');
      }
    });
    const imageUploader = $('<input id="tinymce-uploader" type="file" name="pic" accept="image/*" style="display:none">');
    $(editor.getElement()).parent().append(imageUploader);
    editor.ui.registry.addButton('imageupload', {
      icon: 'image',
      tooltip: 'Insert/edit image',
      onAction: () => imageUploader.trigger('click'),
    });
    imageUploader.on('change', () => {
      const input = imageUploader.get(0);
      const files = input.files;
      handleValidateImageUpload(files, editor, imageUploader);
    });
    const fileUploader = $(
      '<input id="tinymce-uploader-2" type="file" name="file" accept=".pdf, .xls, .xlsx, .doc, .docx, .txt, .ppt, .pptx" style="display:none">'
    );
    $(editor.getElement()).parent().append(fileUploader);
    editor.ui.registry.addButton('fileupload', {
      icon: 'upload',
      tooltip: 'Insert/edit file',
      onAction: () => fileUploader.trigger('click'),
    });
    fileUploader.on('change', () => {
      const input = fileUploader.get(0);
      const files = input.files;
      handleValidateFileUpload(files, editor, fileUploader);
    });
    editor.on('selectionchange', () => {
      if (editor.selection.isCollapsed()) {
        EventBus.$emit('handleSelection', { mode: "Prompt", selected: "" });
        return;
      }
    
      const nativeSelection = window.getSelection();
      if (!nativeSelection.rangeCount) {
        EventBus.$emit('handleSelection', { mode: "Prompt", selected: "" });
        return;
      }
      
      const range = nativeSelection.getRangeAt(0);
      const fragment = range.cloneContents();
      const liElements = fragment.querySelectorAll('li');
      let selectedContent = '';
    
      if (liElements.length > 0) {
        liElements.forEach(li => {
          selectedContent += li.outerHTML;
        });
      } else {
        selectedContent = editor.selection.getContent({ format: 'html' });
      }
      
      EventBus.$emit('handleSelection', { mode: "Selection", selected: selectedContent });
    });
    editor.on('input', () => {
      const dom = editor.dom;
      const elementos = dom.select('p, h1, h2, h3, h4, h5, h6, img, ol, ul, li, span, a'); 
      elementos.forEach(el => {
        if (!el.id) {
          el.id = 'unique-' + Date.now() + '-' + Math.round(Math.random() * 1000000);
        }
      });
    });
    editor.ui.registry.addIcon(
      'genie',
      '<img style="margin-right: 5px; width: 18px; height: 18px" src="/static/roundtable_icons/sparkles.svg" />'
    );
    editor.ui.registry.addButton('genieRevise', {
      icon: 'genie',
      text: "Genie Revise",
      onAction: () => {
      EventBus.$emit('handleRevisePrompt');
      },
    });
  },
};

export { EditorOptions };


// WEBPACK FOOTER //
// ./src/app/features/Drafts/EditorOptions.js